import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hive_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export const CATEGORIES = ["Music", "Comedy", "Sports", "Workshops", "Theatre", "Nightlife", "Travel"];

export const FEES = { commission: 0.05, gst: 0.18, organizerTax: 0.01, adPrice: 1999 };

export function computeFees(unitPrice, qty) {
  const subtotal = unitPrice * qty;
  const commission = subtotal * FEES.commission;
  const gst = commission * FEES.gst;
  return { subtotal, commission, gst, fee: commission + gst, total: subtotal + commission + gst };
}

export function posterSrc(url) {
  return url?.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}

export function seatLabel(r, c) {
  return `${String.fromCharCode(65 + r)}${c + 1}`;
}

export function formatCurrency(n) {
  return `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

export function formatDate(iso) {
  return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function formatDateOnly(iso) {
  return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
